<template>
  <div class="dealer-orders">
    <PageHeader :breadcrumbs="breadcrumbs" icon="mdi-storefront-outline" />
    <DealerOrdersTable
      :orders="orders"
      :stats="stats"
      @accept="onAccept"
      @reject="onRejectRequest"
    />

    <!-- Reject dialog -->
    <v-dialog v-model="rejectDialog" max-width="500">
      <v-card>
        <v-card-title>{{ $t('dealer.orders.rejectDialog.title') }}</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="rejectReason"
            :label="$t('dealer.orders.rejectDialog.reason')"
            rows="3"
            outlined
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="rejectDialog = false">
            {{ $t('dealer.orders.rejectDialog.cancel') }}
          </v-btn>
          <v-btn color="error" @click="onRejectConfirm">
            {{ $t('dealer.orders.rejectDialog.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import DealerOrdersTable from '@/components/DealerOrdersTable';

export default {
  name: 'DealerOrders',

  components: {
    PageHeader,
    DealerOrdersTable,
  },

  data: () => ({
    rejectDialog: false,
    rejectReason: '',
    rejectOrderId: null,
  }),

  computed: {
    breadcrumbs() {
      return [
        {
          text: this.$t('dealer.dashboard.title'),
          to: { name: 'DealerDashboard' },
        },
        {
          text: this.$t('dealer.orders.title'),
          exact: true,
          to: { name: 'DealerOrders' },
        },
      ];
    },

    orders() {
      return this.$store.getters['dealerOrders/dealerOrders'];
    },

    stats() {
      return this.$store.getters['dealerOrders/dealerStats'];
    },
  },

  methods: {
    onAccept(id) {
      this.$store.dispatch('dealerOrders/acceptOrder', id);
    },

    onRejectRequest(id) {
      this.rejectOrderId = id;
      this.rejectReason = '';
      this.rejectDialog = true;
    },

    onRejectConfirm() {
      this.$store.dispatch('dealerOrders/rejectOrder', {
        id: this.rejectOrderId,
        reason: this.rejectReason,
      });
      this.rejectDialog = false;
      this.rejectReason = '';
      this.rejectOrderId = null;
    },
  },
};
</script>
